import { object, string } from 'yup';

import { createValidator } from '@src/validation';
import { reportSettingsStore } from '@stores/dictionaryStores/reportSettings/reportSettingsStore';

const validateSchema = object().shape({
  reportVersionCode: string().required().test('code', 'Настройки отчета для данной версия отчетной формы уже существуют', (value, { parent: { id } }) => {
    const { reportSettings } = reportSettingsStore;
    return !reportSettings.some((report) => report.reportVersionCode === value && report.id !== id);
  })
});

export const validate = createValidator(validateSchema);
